<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="acont" title="Contents">
<p class="h2f1"><span class="right_1" epub:type="pagebreak" id="page_4" title="4"><b>CONTENTS</b></span></p>
<p class="tocp"><span href="#/text/Title" title="Link target outside of Sample"><b>TITLE PAGE</b></span></p>
<p class="toc"><span href="#/text/Copyright" title="Link target outside of Sample"><b>COPYRIGHT PAGE</b></span></p>
<p class="tocp" id="rintr"><a href="#/text/Introduction">Introduction</a></p>
<p class="toc" id="ch1"><a href="#/text/Chapter001">What Are Fatphobia and Diet Culture?</a></p>
<p class="toc" id="ch2"><span href="#/text/Chapter002" title="Link target outside of Sample">Restriction Doesn’t Work: It’s Not You</span></p>
<p class="toc" id="ch3"><span href="#/text/Chapter003" title="Link target outside of Sample">Dieting: Family, Assimilation, and Bootstrapping</span></p>
<p class="toc" id="ch4"><span href="#/text/Chapter004" title="Link target outside of Sample">Dieting Is a Survival Technique</span></p>
<p class="toc" id="ch5"><span href="#/text/Chapter005" title="Link target outside of Sample">Internalized Inferiority and Sexism</span></p>
<p class="toc" id="ch6"><span href="#/text/Chapter006" title="Link target outside of Sample">Bros <img alt="" class="inline" src="images/common.jpg"/><span class="hide"><img alt="" height="12" src="images/common.jpg" width="17"/></span> Thinness: Heteromasculinity and Whiteness</span></p>
<p class="toc" id="ch7"><span href="#/text/Chapter007" title="Link target outside of Sample">Fatphobia Is the New Language of Classism and Racism</span></p>
<p class="toc" id="ch8"><span href="#/text/Chapter008" title="Link target outside of Sample">What Early Fat Activism Taught Me</span></p>
<p class="toc" id="ch9"><span href="#/text/Chapter009" title="Link target outside of Sample">In the Future, I’m Fat</span></p>
<p class="toc" id="ch10"><span href="#/text/Chapter010" title="Link target outside of Sample">I Want Freedom</span></p>
<p class="toc" id="ch11"><span href="#/text/Chapter011" title="Link target outside of Sample">You Have the Right to Remain Fat</span></p>
<p class="toc" id="notes"><span href="#/text/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc" id="ack"><span href="#/text/Acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="tocp" id="ata"><span href="#/text/About_the_Author" title="Link target outside of Sample"><b>ABOUT THE AUTHOR</b></span></p>
<p class="tocf" id="also"><span href="#/text/Also_By" title="Link target outside of Sample">ALSO BY FEMINIST PRESS</span></p>
<p class="tocf" id="atp"><span href="#/text/About_the_Publisher" title="Link target outside of Sample"><b>ABOUT FEMINIST PRESS</b></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?c0285c92